module.exports = __webpack_public_path__ + "static/media/fa-light-300.7c2d0adc.eot";